// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import style from '../styles/PreOrderDate.style';
import { getIconPath, getLocator, getESTDateTime } from '../../../../../../../utils';
import {
  dateFormatter,
  getFormattedPreOrderDate,
  getFormattedPreOrderDateCartPage,
} from '../../../../../../../utils/utils';
import { getLabelFromCopyOrFromTranslation } from '../../../../../../../utils/labels/labelUtilty';
import BAGPAGE_LABELS from '../../../../BagPage/container/Bagpage.labels';

const getCurrentPOD = (currentProduct, formValues, variantPreOrderDateFinal = false) => {
  let preOrderDate = '';
  const today = getESTDateTime();
  // if preOrder date exists -
  if (currentProduct?.miscInfo?.preOrderDate) {
    preOrderDate = dateFormatter(currentProduct?.miscInfo?.preOrderDate);
    preOrderDate = Date.parse(today) > Date.parse(preOrderDate) ? today : preOrderDate;
  }
  // If variants has preOrder dates -
  if (formValues) {
    const size = Array.isArray(formValues) ? formValues[0]?.size : formValues?.size;
    let variantPreOrderDate =
      currentProduct?.miscInfo?.variantPreOrderMap.find((ele) => ele?.size === size)
        ?.preOrderDate || '';
    if (variantPreOrderDate) {
      variantPreOrderDate = dateFormatter(variantPreOrderDate);
      preOrderDate =
        Date.parse(today) > Date.parse(variantPreOrderDate) ? today : variantPreOrderDate;
    }
  }
  if (variantPreOrderDateFinal) {
    preOrderDate =
      Date.parse(today) > Date.parse(variantPreOrderDateFinal)
        ? today
        : dateFormatter(variantPreOrderDateFinal);
  }
  return preOrderDate;
};

const getPreOrderDateBoldText = (newTile, preOrderDateLabel) =>
  !newTile ? preOrderDateLabel?.split('-')?.[0] : '';

const getPreOrderDateShipsBy = (newTile, preOrderDateLabel, estimateToShipBy) =>
  !newTile ? preOrderDateLabel?.split('-')?.[1] : estimateToShipBy;

const PreOrderDate = ({
  showIcon,
  fontSize,
  className,
  blockView,
  newTile,
  formValues,
  currentProduct,
  variantPreOrderDate = false,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  // ToDo: isPDP can be removed when same is needed for through out the site.
  const theme = React.useContext(ThemeContext);
  const {
    lbl_preorder_date: preOrderDateLabel,
    lbl_preorder_items_edd: preOrderItemEdd,
    lbl_estimated_to_ship: estimateToShipBy,
  } = getLabelFromCopyOrFromTranslation('checkout.bagPage', BAGPAGE_LABELS);
  let preOrderDate = getCurrentPOD(currentProduct, formValues, variantPreOrderDate);
  preOrderDate = variantPreOrderDate
    ? getFormattedPreOrderDateCartPage(preOrderDate)
    : getFormattedPreOrderDate(preOrderDate);

  const preOrderDateBoldText = getPreOrderDateBoldText(newTile, preOrderDateLabel);
  const preOrderDateShipsBy = getPreOrderDateShipsBy(newTile, preOrderDateLabel, estimateToShipBy);

  const renderPreOrderDate = () => {
    return (
      <>
        {!blockView ? (
          <BodyCopy component="div" className={className}>
            {showIcon && (
              <Image
                alt=""
                aria-hidden="true"
                src={getIconPath('fast-shipping')}
                className="sth-icon"
                dataLocator={getLocator('sth-icon')}
              />
            )}
            <BodyCopy component="div" className="label-wrapper">
              <BodyCopy
                className="label-ship-by"
                fontFamily="secondary"
                fontSize={fontSize || 'fs14'}
                fontWeight="semibold"
                component="span"
                color="green.500"
              >
                {!newTile ? preOrderItemEdd : estimateToShipBy}
              </BodyCopy>
              <BodyCopy
                fontFamily="secondary"
                className="estimated-shipping-date"
                fontSize={fontSize || 'fs14'}
                fontWeight="extrabold"
                component="span"
                color="green.500"
              >
                {preOrderDate}
              </BodyCopy>
            </BodyCopy>
          </BodyCopy>
        ) : (
          <BodyCopy component="div" className={className}>
            <BodyCopy component="div" className="pod-area-middle">
              <BodyCopy className="pod-estimated-shipping-date" component="div">
                {`${preOrderDateBoldText} - `}
                <BodyCopy
                  fontFamily="secondary"
                  className="estimated-shipping-date"
                  fontWeight="semibold"
                  component="span"
                  color={theme.brandSpecificStyles.EXTENDED_PREORDER_COLOR}
                >
                  {`${preOrderDateShipsBy} ${preOrderDate}`}
                </BodyCopy>
              </BodyCopy>
            </BodyCopy>
          </BodyCopy>
        )}
      </>
    );
  };
  return <>{preOrderDate ? renderPreOrderDate() : null}</>;
};

PreOrderDate.propTypes = {
  spcBag: PropTypes.bool,
  labels: PropTypes.shape({
    preOrderItemEdd: PropTypes.string,
    preOrderDateLabel: PropTypes.string,
  }).isRequired,
  fontSize: PropTypes.string,
  showIcon: PropTypes.bool,
  className: PropTypes.string,
  blockView: PropTypes.bool,
  formValues: PropTypes.shape({}).isRequired,
  currentProduct: PropTypes.shape({}).isRequired,
  variantPreOrderDate: PropTypes.string,
};

PreOrderDate.defaultProps = {
  spcBag: false,
  fontSize: '',
  showIcon: false,
  className: '',
  blockView: false,
  variantPreOrderDate: false,
};

export default withStyles(PreOrderDate, style);

export { PreOrderDate as PreOrderDateVanilla };
